module.exports = __webpack_public_path__ + "img/3-3.c79351d4.svg";